// extracted by mini-css-extract-plugin
export default {"root":"GKxkMsN6HBlpCMFvz34Z","wrap":"EXTDe_F6SEWK6rnj7awA","content":"ZOqyxDfZWFGf0vqEFdG9","table":"JMj3P71XZl7Qvm2_VeVf","header":"Wnj7Gx5N1iDcbRCQBLH8"};